import { css } from "@styled-system/css";

export const togglableClass = css({
	display: "flex",
	alignItems: "center",
	gap: "8",
	marginBottom: "16",
});
